import React from 'react'

import '../css/footer.css'

const Footer = () => {
  return (
    <footer>
      <div className='footer-copyright'>
            <p>© DangryGames All rights reserved.</p>
      </div>
      <div className='footer-nav'>
        <ul>
        <li><a href='https://www.dangrygames.uk/index.html'>Home</a></li>
        <li><a href='https://www.dangrygames.uk/halfbrick.html'>Halfbrick</a></li>
        <li><a href='https://www.dangrygames.uk/solo.html'>Solo</a></li>
        <li><a href='https://www.dangrygames.uk/blog.html'>Blog</a></li>
        <li><a href='https://www.dangrygames.uk/contact.html'>Contact</a></li>
        </ul>
      </div>
      <div className='footer-outside-links'>
        <ul>
            <li><a href='https://x.com/DangryGames' target='_blank'><i className='fa-brands fa-x-twitter' aria-hidden="true"></i></a></li>
            <li><a href="https://bsky.app/profile/dangrygames.bsky.social" target="_blank"><i className="fa-brands fa-bluesky" aria-hidden="true"></i></a></li>
            <li><a href="https://medium.com/@danielkirwan" target="_blank"><i className="fa-brands fa-medium" aria-hidden="true"></i></a></li>
            <li><a href="https://www.youtube.com/@dangrygames" target="_blank"><i className="fa-brands fa-youtube" aria-hidden="true"></i></a></li>
        </ul>
      </div>
    </footer>
  )
}

export default Footer
